import React from 'react'
import SubresellersDetailContainer from 'containers/panel/reseller/subresellers-detail-container'

const SubresellersDetailPage = () => {
  return (
    <SubresellersDetailContainer/>
  )
}

export default SubresellersDetailPage